import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { ASBESTOS_LOG_REPORT_QUERY } from '../../../graphql.js'
import { Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { getData, getInputParams } from '../CustomUtils.js'
import LargeRowHandler from '../LargeRowHandler.js'
import { getTenant } from '../../../utils.js'

const ASBESTOS_LOG_REPORT = gql(ASBESTOS_LOG_REPORT_QUERY)

export default function LogReport({ location }) {
  console.log('LogReport rendered: ', location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const inputs = getInputParams(location)

  useEffect(() => {
    getData(location, ASBESTOS_LOG_REPORT, 'logReport', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const csvUrl = `${process.env.REACT_APP_SERVER}/csv/${getTenant()}/override/Asbestos/logReport/log_report.csv?inputs=${JSON.stringify(inputs)}`
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl} resultsLength={0} />
        </div>
        <div dangerouslySetInnerHTML={{ __html: results }} />
      </div>
    )
  }
}
